// extracted by mini-css-extract-plugin
var _1 = "page--not-found-module__container--L2FwcC";
export { _1 as "container" }
